<div class="search-description">Start typing a name or email to add to your project</div>
<app-azure-ad-search (add)="addTeamMember($event)"></app-azure-ad-search>
<mat-divider></mat-divider>
<!-- todo: if we want users to have multiple project roles in the future, this only counts for one right now -->
@if (teamMembers) {
<app-search-edit-members
  [teamMembers]="teamMembers"
  [newProject]="newProject"
  (updated)="updateBtnLabelSubject.next()"
  (delete)="removeMember($event)"
  #searchEdit
></app-search-edit-members>
<div class="edit-buttons">
  @if (newProject) {
  <button class="iconf-btn-filled minh40 minw150" (click)="onSave()">
    {{ (isUnedited$ | async) ? 'add later' : 'save and continue' }}
  </button>
  } @if (!newProject) {
  <button class="iconf-btn-blank minw100 margin-border" mat-dialog-close>cancel</button>
  <button class="iconf-btn-blank selected minw100 margin-border" mat-dialog-close (click)="onSave()">save</button>
  }
</div>
}
